import { gql } from '@apollo/client';

export const ALL_TEMPLATE_ADMINISTRATION = gql`
  query getTemplateAdministrations {
    templateAdministrations: getTemplateAdministrations {
      id
      name
    }
  }
`;
